import { useCallback, useState } from "react";
import {
  ClienteAdd,
  ClienteDelete,
  ClienteGet,
  ClienteUpdate,
} from "../service/clientes";

export default function useCliente() {
  // Estado de carga del listado: los servicios Add/Update/Delete ya movían
  // State.loading, pero el GET no, y las tablas no tenían cómo saber que
  // todavía estaban esperando datos.
  const [cargando, setCargando] = useState(false);

  const [Clientes, setClientes] = useState([]);
  const [State, setState] = useState({
    loading: false,
    error: false,
    message: "",
    success: false,
  });

  const ClienteGetService = useCallback((token) => {
    setCargando(true);
    ClienteGet(token).then((response) => {
      if (response.success) {
        setClientes(response?.data ?? []);
      }
    }).finally(() => setCargando(false));
  }, []);
  /*
   * Agregar Cliente
   */
  const ClienteAddService = useCallback((data, token) => {
    setState({
      loading: true,
      error: false,
      message: "",
      success: false,
    });
    ClienteAdd(data, token).then((response) => {
      if (response.success) {
        setState({
          loading: false,
          error: false,
          message: "Cliente registrado con exito",
          success: true,
        });
      } else {
        const primerError = response.data ? Object.values(response.data)[0] : null;
        setState({
          loading: false,
          error: true,
          message: primerError ? primerError[0] : response.message ?? "No se pudo registrar el cliente",
          success: false,
        });
      }
    }).catch(() => {
      setState({ loading: false, error: true, message: "No se pudo conectar con el servidor", success: false });
    });
  }, []);

  /*
   * Actualizar Cliente
   */
  const ClienteUpdateService = useCallback((data, token) => {
    setState({
      loading: true,
      error: false,
      message: "",
      success: false,
    });
    ClienteUpdate(data, token).then((response) => {
      if (response.success) {
        setState({
          loading: false,
          error: false,
          message: "Cliente actualizado con exito",
          success: true,
        });
      } else {
        const primerError = response.data ? Object.values(response.data)[0] : null;
        setState({
          loading: false,
          error: true,
          message: primerError ? primerError[0] : response.message ?? "No se pudo actualizar el cliente",
          success: false,
        });
      }
    }).catch(() => {
      setState({ loading: false, error: true, message: "No se pudo conectar con el servidor", success: false });
    });
  }, []);
  /*
   * Eliminar Cliente
   */
  const ClienteDeleteService = useCallback((data, token) => {
    setState({
      loading: true,
      error: false,
      message: "",
      success: false,
    });
    ClienteDelete(data, token).then((response) => {
      if (response.success) {
        setState({
          loading: false,
          error: false,
          message: "Cliente eliminado con exito",
          success: true,
        });
      } else {
        setState({
          loading: false,
          error: true,
          message: "Error al eliminar Cliente",
          success: false,
        });
      }
    }).catch(() => {
      setState({ loading: false, error: true, message: "No se pudo conectar con el servidor", success: false });
    });
  }, []);

  return {
    loading: State.loading || cargando,
    error: State.error,
    message: State.message,
    success: State.success,
    Clientes,
    ClienteGetService,
    ClienteAddService,
    ClienteUpdateService,
    ClienteDeleteService,
  };
}
